import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, timeout: 25000 });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ham_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  // Per-request retry config:
  //   - GET: safe to retry (idempotent) — 6 attempts
  //   - PUT/DELETE: idempotent by REST semantics — 1 retry (keep UX fast; 60s * 3 retries is way too long)
  //   - POST/PATCH: never auto-retried (would risk duplicates); callers handle manually
  if (config.__retry == null) {
    const method = (config.method || "get").toLowerCase();
    config.__retry = method === "get" ? 6 : (method === "put" || method === "delete") ? 1 : 0;
    config.__retryDelay = 1000;
  }
  return config;
});

// Retry on network errors, timeouts, 502/503/504, and Cloudflare 520/521/522/524 (cold-start scenarios).
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const cfg = error.config;
    if (!cfg || !cfg.__retry) return Promise.reject(error);
    const status = error.response?.status;
    const retriable =
      !error.response ||
      status === 502 || status === 503 || status === 504 ||
      status === 520 || status === 521 || status === 522 || status === 524 ||
      error.code === "ECONNABORTED" || error.code === "ERR_NETWORK";
    if (!retriable) return Promise.reject(error);
    cfg.__retry -= 1;
    const delay = cfg.__retryDelay;
    cfg.__retryDelay = Math.min(delay * 2, 8000);
    await new Promise((r) => setTimeout(r, delay));
    return api.request(cfg);
  }
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Algo salió mal. Inténtalo de nuevo.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export { API };
export default api;
